export default __webpack_public_path__ + "static/media/icon-error.9d2d7c49.svg";